/**
 * VineyardToursCard.js — Halleck /vineyard-tours/ promo card.
 *
 * Parity with old main.js addVineyardCard(): image + italic caption +
 * "Learn More" → RedChirp contact form (starterTextLivePerson).
 *
 * Image URL comes from tenant theme `vineyard_tours_image_url` (admin panel).
 *
 * message.kind: "vineyard-tours-card"
 * message.data: { image_url?, caption?, cta_label? }
 */

import { emit } from "../../../core/state.js";
import { getTheme } from "../../../core/configAccessors.js";

const DEFAULT_CAPTION =
  "Guests at a wine tasting at our Sebastopol Estate Vineyard Winery.";

export default class VineyardToursCard {
  render(message) {
    const data = message?.data || {};
    const imageUrl =
      data.image_url || getTheme("vineyard_tours_image_url", null);
    const caption =
      data.caption ||
      getTheme("vineyard_tours_caption", null) ||
      DEFAULT_CAPTION;
    const ctaLabel = data.cta_label || "Learn More";

    if (!imageUrl) return null;

    const wrap = document.createElement("div");
    wrap.className = "ws-vineyard-tours-wrap";

    const card = document.createElement("div");
    card.className = "ws-vineyard-tours-card";

    const img = document.createElement("img");
    img.className = "ws-vineyard-tours-image";
    img.src = imageUrl;
    img.alt = caption;
    img.loading = "lazy";
    card.appendChild(img);

    const cap = document.createElement("p");
    cap.className = "ws-vineyard-tours-caption";
    cap.textContent = caption;
    card.appendChild(cap);

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "ws-vineyard-tours-learn-more";
    btn.textContent = ctaLabel;
    btn.addEventListener("click", () => {
      emit("ws-vineyard-tours-learn-more");
    });
    card.appendChild(btn);

    wrap.appendChild(card);
    return wrap;
  }
}
